import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";
import { enqueueSnackbar } from "notistack";

const createEventDiscount = async (user, data, logout) => {
    const storageAvailable = localStorageAvailable();

    const accessToken = storageAvailable
        ? localStorage.getItem("accessToken")
        : "";
    const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `/service/events_service/v1/events/discount-coupon/generate`,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        },
        data: data,
    };
    try {
        const response = await axios.request(config);
        return response;
    } catch (error) {
        
        if (error?.data === "Verification timeout") {
            return;
        }
        if (error?.status === 401) {
            enqueueSnackbar("Un Authorized Request", {
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            });
            logout();
        }
        
        enqueueSnackbar(error?.data?.message, {
            variant: "error",
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
        });
    }
};

export default createEventDiscount;
